/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as l from "react";
import { classNames as t } from "@progress/kendo-react-common";
const r = (e) => {
  const a = t(
    {
      "k-form-field": !0,
      "k-rtl": e.dir === "rtl"
    },
    e.className
  );
  return /* @__PURE__ */ l.createElement("div", { className: a, style: e.style }, e.children);
};
r.displayName = "KendoReactFieldWrapper";
export {
  r as FieldWrapper
};
